import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import StarryNightSky from "./Stars";
import ThankYouModal from "./Thankyou";
import PhoneInput from "react-phone-input-2";

const FormSec = () => {
  const showText = `Your details have been successfully submitted!
          <br />
          We'll email you soon.`;
  const [showModal, setShowModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    subject: " ",
    phoneNumber: "",
    contactMedium: "coaler",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const preventPageScrollOnDropdown = (e) => {
      const dropdown = document.querySelector(".custom-dropdown");
      if (dropdown && dropdown.contains(e.target)) {
        e.stopPropagation();
      }
    };

    // Attach the event
    document.addEventListener("wheel", preventPageScrollOnDropdown, {
      passive: false,
    });

    // Clean up on unmount
    return () => {
      document.removeEventListener("wheel", preventPageScrollOnDropdown);
    };
  }, []);
  const handlePhoneChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      phoneNumber: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-left",
      });
      setIsSubmitting(false);
      return;
    }

    const updatedFormData = {
      ...formData,
      name: `${firstName} ${lastName}`,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/starLabs/newContactUs`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFormData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log("SUCCESS!", result);
        toast.success("Message sent successfully!");

        setFormData({
          name: "",
          email: "",
          message: "",
          subject: "",
          phoneNumber: "",
        });
        setFirstName("");
        setLastName("");
        setShowModal(true);
      } else {
        throw new Error("Network response was not ok.");
      }
    } catch (error) {
      console.error("FAILED...", error);
      toast.error("Failed to send message. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="relative text-white bg-black bg-cover w-screen flex justify-center p-10 "
      id="contact"
    >
      <StarryNightSky height="100vh" />
      <div className="relative mx-auto  md:w-[1000px] rounded-[48px] backdrop-blur-[300px] bg-[#FFFFFF1A] px-4 md:p-8 transition-all duration-300 ease-in-out hover:bg-[#87818182] hover:shadow-[0_0_60px_20px_rgba(255,255,255,0.2)]">
        <div className="md:pt-8 md:pr-5 pb-8 md:pl-6 grid gap-8 lg:grid-cols-[1fr_2fr]">
          <div className="flex flex-col gap-4 mt-12 z-10">
            <h1 className="font-black text-2xl md:text-4xl leading-[1.3]">
              Still have questions??
            </h1>
            <p className="font-normal text-[18px] leading-[150%] tracking-[0%]">
              Our team is here to help you.
            </p>
          </div>
          <div className="relative flex justify-center ">
            <div
              className="absolute top-10 md:top-20 bottom-20 h-[650px] md:w-[550px] w-full md:h-[335px] 
  rounded-full pointer-events-none 
  bg-[#5A8CF0] opacity-50 
  shadow-[0_0_150px_#5A8CF0,_0_0_250px_#34518A] 
  blur-3xl"
            ></div>

            <form
              onSubmit={handleSubmit}
              className="md:mt-12 space-y-10 relative z-10 w-full md:px-8"
            >
              <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
                <div>
                  <label
                    htmlFor="firstName"
                    className="block mb-1 font-semibold text-white"
                  >
                    First name<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                    placeholder="Enter first name"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="lastName"
                    className="block mb-1 font-semibold text-white"
                  >
                    Last name<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="w-full p-1 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                    placeholder="Enter last name"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-1 font-semibold text-white"
                  >
                    Email address<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                    placeholder="Enter email"
                    required
                  />
                </div>

                <div className="contact">
                  <label
                    htmlFor="phoneNumber"
                    className="block mb-1 font-semibold text-white "
                  >
                    Phone number
                  </label>
                  <PhoneInput
                    id="phoneNumber"
                    country={"in"} // Default country code
                    value={formData.phoneNumber}
                    onChange={handlePhoneChange}
                    containerClass="w-full"
                    inputClass="!w-full !h-[2.65rem] !bg-transparent !rounded-none !border-b-2 !border-0  !text-gray-200 !pl-11 "
                    buttonClass="!bg-transparent !border-0 !text-white"
                    dropdownClass="!bg-black !text-white custom-dropdown" // Add this class
                    searchClass="!bg-black !text-white !border-red-400"
                    required
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="subject"
                  className="block mb-1 font-semibold text-white"
                >
                  Subject<span className="text-red-500">*</span>
                </label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                  placeholder="Enter subject"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block md:mb-1 font-semibold text-white"
                >
                  Message<span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500 min-h-[100px]"
                  placeholder="Type your message here"
                  required
                />
              </div>

              <div className="w-full text-center">
                <button
                  type="submit"
                  className="w-8/12 p-2 font-semibold text-center text-black transition-all rounded-lg lg:w-full lg:p-3 bg-[#1B0073] hover:bg-blue-600"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showModal && (
        <ThankYouModal
          texttoShow={showText}
          onClose={() => setShowModal(false)}
        />
      )}
    </section>
  );
};

export default FormSec;
